// src/components/AdminOnlyRoute.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/useAuthStore';
import { Result, Button } from 'antd';

interface AdminOnlyRouteProps {
  children: React.ReactNode;
}

const AdminOnlyRoute: React.FC<AdminOnlyRouteProps> = ({ children }) => {
  const currentUser = useAuthStore((state) => state.currentUser);

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (currentUser.role !== 'admin') {
    return (
      <Result
        status="403"
        title="403"
        subTitle="Lo sentimos, no tienes permisos para acceder a esta página."
        extra={<Button type="primary" href="/dashboard">Volver al Dashboard</Button>}
      />
    );
  }

  return <>{children}</>;
};

export default AdminOnlyRoute;
